{
	"customise_experience": {
		"add_more": "और अधिक जोड़ने",
		"celebratory_dates": "जश्न की तारीख (वैकल्पिक)",
		"customise_experience": "अपने अनुभव को अनुकूलित",
		"greetings": "बधाई",
		"language_preference": "भाषा वरीयता (वैकल्पिक)",
		"your_birthday": "अपने जन्मदिन",
		"add_preferences": "जोड़ें वरीयताओं (वैकल्पिक)"
	},
	"atHotelWelcome": {
		"Welcome": "आपका स्वागत है",
		"Check_photo": "जांच में एक तस्वीर के साथ",
		"Share_Photo": "अपनी तस्वीर साझा करें",
		"Explore_Redeem_Benifites": "का पता लगाने होटल और लाभ के एवज में"
	},
	"athotelExplore": {
		"title": "का पता लगाने होटल और लाभ के एवज में",
		"Hotel_video_view": "होटल वीडियो - 360 डिग्री देखें",
		"Need_Assistance": "सहायता की जरूरत है होटल में?",
		"Contact_club_Marriot": "संपर्क {{brandName}} संबंध प्रबंधक",
		"Explore_Redeem_Benifites": "का पता लगाने होटल और लाभ के एवज में",
		"Fine_Dinning": "भोजन",
		"Health_And_Rejuvenation": "स्वास्थ्य और कायाकल्प",
		"Luxary_Stay": "रहने",
		"terms": "नियम और शर्त",
		"create_a_memory": "एक स्मृति बनाने",
		"check_in_photo": "जांच में एक तस्वीर के साथ"
	},
	"enroll_for_property": {
		"choose_from_profile": "से चुनने मेरे प्रोफाइल",
		"customise_membership": "अनुकूलित सदस्यता",
		"discount": "छूट",
		"enroll_for_marriott": "नामांकन के लिए {{brandName}}",
		"enter_gst": "जीएसटी संख्या दर्ज करें",
		"gst": "जीएसटी",
		"gst_information": "जीएसटी की जानकारी (वैकल्पिक)",
		"gst_invoice_receipt": "जीएसटी के रसीद के लिए चालान लेन-देन की संख्या {{transactionNumber}} और रसीद को भेजी जाएगी",
		"gst_invoice_receipt_without_transaction": "जीएसटी के रसीद, चालान और रसीद को भेजी जाएगी",
		"gst_invoice_without_receipt": "एक रसीद, चालान लेन-देन की संख्या के लिए {{transactionNumber}} को भेजी जाएगी",
		"gst_invoice_without_receipt_without_transaction": "एक रसीद, चालान भेजा जाएगा करने के लिए",
		"hotel": "होटल",
		"level": "स्तर",
		"net_price": "निवल मूल्य",
		"or": "या",
		"pay_now": "अब भुगतान",
		"paid": "Paid",
		"price": "कीमत",
		"promo_code_applied": "प्रोमो कोड लागू किया",
		"registered_company": "पंजीकृत कंपनी का नाम",
		"registered_email": "अपने पंजीकृत ईमेल पते.",
		"save_to_profile": "विवरण को बचाने के लिए, मेरे प्रोफाइल",
		"total_price": "कुल कीमत",
		"welcome_to_marriott": "आपका स्वागत है करने के लिए {{brandName}}",
		"your_membership_is": "अपनी सदस्यता संख्या है",
		"title": "नामांकन के लिए संपत्ति",
		"dear": "प्रिय",
		"activation_link": "एक सक्रियण लिंक पर भेजा गया ईमेल और एसएमएस",
		"wantToEnableFingerprint": "क्या आप चाहते हैं करने के लिए सक्षम करने के लिए फिंगरप्रिंट में लॉग इन करें ?",
		"fingerprintFastEasy": "फिंगरप्रिंट एक तेज और आसान तरीका करने के लिए अपने खाते में प्रवेश करें.",
		"enableFingerprint": "सक्षम फिंगरप्रिंट",
		"addGstInformation": "जोड़ें जीएसटी की जानकारी (वैकल्पिक)",
		"enableFaceID": "क्या आप चाहते हैं को सक्षम करने के लिए का सामना करने के लिए आईडी में लॉग इन करें ?",
		"faceIDFastEasy": "चेहरा पहचान है एक तेज और आसान तरीका करने के लिए अपने खाते में प्रवेश करें.",
		"enableFace": "सक्षम चेहरा आईडी",
		"pay_with_ecash": "Pay with E-cash",
		"totalEcash": "Total E-cash Value",
		"balancePay": "Balance to Pay",
		"paymentUnsuccessfullHeader": "Payment Unsuccessful!",
		"paymentUnsuccessfullMessage": "We could not process your payment at the moment. We request you to try again.",
		"paymentAwaitingHeader": "Payment Awaiting",
		"paymentAwaitingMessage": "Payment will be completed in 24 hours. For immediate assistance, you may contact us at 18001021030 or email us at member.care@clubmarriott.in",
		"paymentPendingHeader": "Payment Aborted/Pending",
		"paymentpendingMessage": "In case of any deduction from account, deducted amount will be credited in your bank acount between 7 working days. You may contact us at 18001021030 or email us at member.care@clubmarriott.in for any assistance."
	},
	"branch": {
		"branch_Message": "अमान्य सदस्यता आईडी",
		"branch_Message_Reservation": "आपको लगता है कि आपने किसी अन्य सदस्यता खाते से आरक्षण का अनुरोध किया है। आरक्षण अनुरोध को संपादित करने के लिए कृपया अपना खाता स्विच करें।",
		"branch_Message_Renew": "ऐसा लगता है कि आपने किसी भिन्न सदस्यता खाते से नवीनीकरण का अनुरोध किया है। नवीनीकरण सदस्यता को अपडेट करने के लिए कृपया अपना खाता बदलें",
		"welcoming_rc_popup": "हम आज आपका स्वागत करने के लिए उत्सुक हैं!"
	},
	"login": {
		"enter_email": "ईमेल दर्ज करें",
		"enter_mobile_number": "मोबाइल नंबर दर्ज करें",
		"enter_password": "पासवर्ड दर्ज करें",
		"forgot_password": "पासवर्ड भूल गए?",
		"login_delaration": "मैं सहमति का उपयोग करने के लिए अपने व्यक्तिगत डेटा से टीएलसी और अपने कार्यक्रम के भागीदारों और होटल भागीदारों भेजने के लिए प्रदान करता है या प्रोन्नति के माध्यम से मुझे ईमेल, टेलीफोन, संदेश या मेल के साथ लगातार संचार वरीयताओं मैं चुनाव समय से समय के लिए.",
		"login_with_email": "ईमेल के साथ लॉगिन",
		"login_with_mobile": "लॉगिन के साथ मोबाइल",
		"select_membership": "का चयन एक सदस्यता",
		"submit": "प्रस्तुत",
		"proceed": "आगे बढ़ें",
		"valid_through": "के माध्यम से मान्य",
		"reset_password": "पासवर्ड रीसेट करें",
		"set_new_password": "नया पासवर्ड सेट",
		"confirm_password": "पासवर्ड की पुष्टि करें",
		"characters": "8-20 अक्षर",
		"lowercase": "1 लोअरकेस वर्ण",
		"uppercase": "1 अपरकेस चरित्र",
		"number": "1 संख्या",
		"no_username": "कोई उपयोगकर्ता नाम, ईमेल या मोबाइल नंबर",
		"re_enter_password": "फिर से पासवर्ड दर्ज करें",
		"change_password": "पासवर्ड बदलें",
		"specialCharacter": "1 विशेष चरित्र",
		"stageSignup201": "एक पाठ संदेश उपयोगकर्ता के लिए ही किया जाता सेटअप प्रोफाइल और पूछा कि आगे बढ़ने के लिए पूरा करने के लिए सदस्यता सक्रियण और ताला खोलने के लाभ प्रक्रिया",
		"stageSignup202": "एक पाठ संदेश के लिए उपयोगकर्ता पूरा हो गया उसका\/उसकी सदस्यता सक्रियण लेकिन नहीं खुला है उसकी\/उसके लाभ",
		"successfullyChangedPassword": "आप सफलतापूर्वक अपना पासवर्ड बदला है. लॉगिन के साथ अपने नए पासवर्ड को । ",
		"leaveMessage": "एक संदेश छोड़ें",
		"Login_with_OTP": "ओटीपी के साथ लॉगिन करें",
		"OTP_has_been_sent": "उपरोक्त नंबर पर एक ओटीपी भेजा गया है"
	},
	"membership_home": {
		"view_all": "सभी देखें",
		"expiry": "दिन की समाप्ति के लिए",
		"valid": "वैध माध्यम से ",
		"at": " पर ",
		"reactivate_Membership": "फिर से सक्रिय {{brandName}} सदस्यता",
		"renew_Now": "अब नवीनीकृत",
		"upcoming_ReserveHeader": "आगामी आरक्षण",
		"celeb_DatesHeader": "उत्सव तिथियाँ",
		"no_ReserveText": "कोई आगामी आरक्षण",
		"add_CelebText": "+ जोड़ें जश्न की तारीख",
		"gift_MembershipText": "उपहार एक {{brandName}} सदस्यता",
		"buyMembership_NoCardBenefit": "Buy a membership to enjoy year long card benefits",
		"no_content": "कोई सामग्री उपलब्ध",
		"visitor": "आगंतुक",
		"visitor_card": "में शामिल हों {{brandName}} सदस्यता",
		"gift_Upload": "फोटो अपलोड करें",
		"gift_Photo": "एक तस्वीर को जोड़ने में मदद करने के लिए हमें अपने अनुभव को निजीकृत.",
		"guest_user_modal_txt": "इस लाभ के लिए उपलब्ध नहीं है अतिथि उपयोगकर्ताओं के लिए है । आप बन सकते हैं एक {{brandName}} के सदस्य अब.",
		"guest_user_modal_btn": "बन {{brandName}} के सदस्य",
		"termsConditions": "नियम एवं शर्तें",
		"level_Benefits": "स्तर लाभ"
	},
	"password": {
		"1_lowercase_character": "1 लोअरकेस वर्ण",
		"1_number": "1 संख्या",
		"1_uppercase_character": "1 अपरकेस चरित्र",
		"8_20_characters": "8 - 20 वर्ण",
		"enter_new_password": "पासवर्ड बनाएँ",
		"enter_new_password_required": "कृपया पासवर्ड नीति का पालन करें।",
		"password_should_match": "पासवर्ड मैच नहीं करता है",
		"re_enter_password": "फिर से पासवर्ड दर्ज करें",
		"username_email_mobile_required": "कोई उपयोगकर्ता नाम, उपयोगकर्ता ईमेल या उपयोगकर्ता के मोबाइल नंबर",
		"password_already_set": "पासवर्ड पहले से ही निर्धारित किया गया के लिए खाते. कृपया लॉगिन."
	},
	"privacy_statement": {
		"confirm": "इस बात की पुष्टि",
		"proceed": "आगे बढ़ें",
		"declaration": "घोषणा",
		"no_data_found": "कोई डेटा नहीं पाया",
		"privacy_statement": "गोपनीयता कथन",
		"goodMorning": "सुप्रभात",
		"goodAfternoon": "अच्छा दोपहर",
		"goodEvening": "अच्छी शाम",
		"noDataFound": "कोई डेटा नहीं पाया!"
	},
	"query": {
		"call": "कॉल",
		"chat_now": "अब चैट",
		"email": "ईमेल",
		"giftMembershipQuery": "यदि आप चाहते हैं उपहार के लिए कई की सदस्यता, कृपया संपर्क करें हमारे मेहमान मदद डेस्क.",
		"loginQuery": "के लिए लॉगिन से संबंधित प्रश्नों",
		"membershipQuery": "यदि आप चाहते हैं खरीद करने के लिए एक से अधिक सदस्यता है, तो कृपया संपर्क करें हमारे संपर्क केंद्र",
		"reactivationQuery": "के लिए फिर से सक्रियण से संबंधित प्रश्नों",
		"referralQuery": "रेफरल के लिए से संबंधित प्रश्नों",
		"serviceQuery": "के साथ कनेक्ट हमारे {{brandName}} दरबान अधिक पता करने के लिए",
		"activationRelatedQuery": "सक्रियण के लिए से संबंधित प्रश्नों",
		"signupQuery": "के लिए साइन अप करें से संबंधित प्रश्नों",
		"chat": "चैट",
		"chatAll": "हमारे लाइव सहायता से उपलब्ध है 9:00 बजे से 9:00 PM IST. पर अपनी प्रतिक्रिया छोड़ दें feedback.uat.cm@tlcgroup.com",
		"gotIt": "यह मिल गया",
		"knowMore": "अधिक पता",
		"readTC": "पढ़ें T&C",
		"thankYou": "धन्यवाद",
		"renewalQuery": "नवीनीकरण संबंधी प्रश्नों के लिए",
		"forgotAfterLogin": "पासवर्ड संबंधी प्रश्नों के लिए",
		"reservation": "अधिक जानने के लिए हमारी कंसीयज के साथ जुड़ें"
	},
	"register_user": {
		"OTP_will_be_sent": "आपके पंजीकृत मोबाइल नंबर और ईमेल पर एक ओटीपी भेजा जाएगा।", 
		"enter_email": "ईमेल दर्ज करें",
		"email": "ईमेल",
		"enter_name": "नाम दर्ज करें",
		"name": "नाम",
		"first_name_accepts_characters_only": "अमान्य नाम",
		"last_name_accepts_characters_only": "अमान्य अंतिम नाम",
		"enter_mobile_number": "मोबाइल नंबर दर्ज करें",
		"mobile_number": "मोबाइल नंबर",
		"mr": "श्री",
		"ms": "Ms",
		"mrs": "श्रीमती",
		"please_enter_a_valid_email": "कृपया एक मान्य ईमेल पता दर्ज",
		"please_enter_a_valid_mobile_number": "कृपया एक मान्य मोबाइल नंबर",
		"please_share_your_details": "कृपया अपने विवरण का हिस्सा",
		"proceed": "आगे बढ़ें",
		"verified": "सत्यापित",
		"enter_membership_number": "सदस्यता संख्या दर्ज करें",
		"first_name": "पहला नाम",
		"last_name": "अंतिम नाम",
		"first_name_required": "पहला नाम रिक्त नहीं हो सकता",
		"last_name_required": "अंतिम नाम रिक्त नहीं हो सकता",
		"mobile_number_required": "मोबाइल नंबर रिक्त नहीं हो सकता",
		"email_required": "ईमेल आईडी रिक्त नहीं हो सकता",
		"membership_number": "सदस्यता संख्या",
		"activate_membership": "कृपया एक मान्य सदस्यता संख्या",
		"invalid_membership": "अमान्य सदस्यता!",
		"enableFaceIDFingerprint": "सक्षम चेहरा आईडी \/ फिंगरप्रिंट के साथ लॉगिन",
		"enterEmailId": "दर्ज ईमेल आईडी",
		"reEnterEmail":"ईमेल पुन: दर्ज करें",
		"please_re_enter_email":"कृपया ईमेल पुनः दर्ज करें",
		"leavePersonelMessage": "छोड़ एक निजी संदेश या एक वीडियो में शामिल",
		"leavePersonelMessageGiftMembership": "छोड़ एक निजी संदेश",
		"type_a_message": "संदेश लिखें"
	},
	"setup_profile": {
		"enter_name": "नाम दर्ज करें",
		"name": "नाम",
		"promocode_for_special_benefit": "मैं एक प्रोमो कोड के लिए विशेष सदस्यता लाभ है । ",
		"setup_your_profile": "सेटअप अपने प्रोफ़ाइल",
		"upload_photo_msg": "फोटो की पुष्टि करने के लिए पहचान और अपने अनुभव को अनुकूलित",
		"discount": " छूट लागू"
	},
	"signup_program_benefits": {
		"discount_applied": "छूट लागू",
		"key_features": "मुख्य विशेषताएं",
		"promo_code": "प्रोमो कोड",
		"select_city": "शहर का चयन करें",
		"select_country": "देश का चयन करें",
		"select_level": "स्तर का चयन करें",
		"select_preferred_hotel": "पसंदीदा होटल का चयन करें",
		"skip": "छोड़ें",
		"welcome": "आपका स्वागत है",
		"view_benefits": "देखने के लाभ",
		"spouse": "जीवनसाथी सदस्यता",
		"viewBenefit": "देखने के लाभ",
		"unlockBenefit": "आगे बढ़ें",
		"enterPromocode": "दर्ज करें अपने Promocode या जारी रखने के लिए एक अतिथि के रूप में",
		"selectPreferedHotel": "कृपया अपने पसंदीदा {{brandName}} होटल का चयन करें ताकि हम आपको नवीनतम ऑफ़र और प्रचारों पर अपडेट कर सकें।"
	},
	"spouse_membership": {
		"complimentary_membership": "अपनी सदस्यता के साथ आता है एक मानार्थ सदस्यता के लिए अपने पति",
		"dr": "Dr",
		"first_name": "पहला नाम",
		"last_name": "अंतिम नाम",
		"membership_at_a_special_price": "अपने लाभ के साथ आते हैं एक सदस्यता पति या पत्नी के लिए एक विशेष कीमत पर की",
		"spouse_membership": "जीवनसाथी सदस्यता",
		"activation_link": "एक सक्रियण लिंक",
		"sent_to_email": "पर भेजा गया ईमेल और एसएमएस",
		"mobile_already": "मोबाइल नंबर पहले से ही मौजूद हैं!",
		"email_already": "ई-मेल आईडी पहले से ही मौजूद हैं!",
		"proceed": "आगे बढ़ना करने के लिए भुगतान",
		"okay": "ठीक है",
		"spouse_creation": "प्रिय {{memberName}}, अपने लेन-देन की संख्या है {{transactionNumber}}. सदस्यता विवरण भेजा गया ईमेल और एसएमएस के {{spouseFirstName}} {{spouseLastName}}",
		"spouse_creation_without_transaction": "प्रिय {{memberName}}, एक सक्रियण लिंक पर भेजा गया ईमेल और एसएमएस के {{spouseFirstName}} {{spouseLastName}}",
		"renew_spouse": "नवीनीकृत जीवनसाथी",
		"renew_spouse_membership": "नवीनीकृत जीवनसाथी सदस्यता",
		"transactionNumber": "अपने लेन-देन की संख्या है {{transactionNumber}}.",
		"spouse_renewal_msg": "आपका भुगतान सफल रहा है और लेन-देन की संख्या है {{transactionNumber}}. साथी सदस्यता के लिए {{spouseFirstName}} {{spouseLastName}} नए सिरे से किया गया है और लाभ उपलब्ध हैं पर उनकी सदस्यता पृष्ठ.",
		"spouse_renewal_msg_without_transaction": "साथी सदस्यता के लिए {{spouseFirstName}} {{spouseLastName}} नए सिरे से किया गया है और लाभ उपलब्ध हैं पर उनकी सदस्यता पृष्ठ.",
		"spouseMembershipAlert": "आप नहीं कर सकते हैं {{कार्रवाई}} सदस्यता के रूप में आप कर रहे हैं जीवनसाथी के सदस्य है । पूछने के लिए कृपया अपने माता पिता के सदस्य अपनी सदस्यता को नवीनीकृत या संपर्क करने के लिए हमारे ग्राहक देखभाल."
	},
	"app_benefits": {
		"select_fav_hotel": "अपने पसंदीदा होटल का चयन करें",
		"membership_program": "के {{brandName}} सदस्यता कार्यक्रम है । ",
		"video_tag_support": "अपने ब्राउज़र से वीडियो का समर्थन नहीं करता । "
	},
	"tabs": {
		"activites": "गतिविधियों",
		"chat": "चैट",
		"home": "घर",
		"membership": "सदस्यता",
		"profile": "प्रोफ़ाइल"
	},
	"unlock_benefits": {
		"program_benefits": "{{brandName}} कार्यक्रम के लाभ",
		"unlock_benfits": "आगे बढ़ें",
		"key_feature": "मुख्य विशेषताएं",
		"benefitsLocked": "अपने लाभ नहीं किया गया है खुला. लॉगिन करने के लिए, कृपया अनलॉक अपने लाभ."
	},
	"welcome": {
		"activate_membership": "सक्रिय सदस्यता",
		"login": "लॉगिन",
		"signup": "साइन अप करें",
		"description1": "अनुभवों और लाभों का संग्रह",
		"description2": " {{brandName}} होटल्स में अद्वितीय अनुभव खरीदें और उपहार ",
		"description3": "अनुकूलित ऑफ़र, प्रचार, ईवेंट और बहुत कुछ ..",
		"description4": "डिजिटल सदस्यता और त्वरित आरक्षण",
		"description5": "APAC में 350 से अधिक भाग लेने वाले {{brandName}} होटल"
	},
	"profile": {
		"salutation": "नमस्कार",
		"title": "प्रोफ़ाइल",
		"of_your_profile_is_complete": "के लिए अपने प्रोफ़ाइल पूरा",
		"updateProfile": "अद्यतन प्रोफ़ाइल",
		"wallet": "कार्ड वॉलेट",
		"settings": "सेटिंग्स",
		"notifications": "सूचनाएं",
		"contactUs": "हमसे संपर्क करें",
		"feedback": "प्रतिक्रिया",
		"faqs": "पूछे जाने वाले प्रश्न",
		"aboutUs": "हमारे बारे में",
		"log_out": "लॉग आउट",
		"enterValidGST": "दर्ज करें वैध जीएसटी संख्या.",
		"gstNumber": "11ABCDE123412Z3",
		"enterGstCompany": "दर्ज करें जीएसटी कंपनी",
		"enterValidGstDetails": "दर्ज करें वैध जीएसटी विवरण!",
		"my_birthday": "मेरा जन्मदिन",
		"my_anniversary": "मेरी शादी की सालगिरह",
		"update_my_birthday": "अद्यतन मेरा जन्मदिन",
		"update_my_anniversary": "अद्यतन मेरी शादी की सालगिरह",
		"enterValidPincode": "दर्ज करें वैध पिन कोड.",
		"addBirthday": "जन्मदिन जोड़ें",
		"addAnniversary": "जोड़ने की सालगिरह",
		"countrygstmismatching": "दर्ज किया गया GST नंबर और चयनित राज्य मेल नहीं खाता।",
		"countryPincodeMismatching": "दर्ज किया गया पिन कोड चयनित राज्य से मेल नहीं खाता।"
	},
	"settings": {
		"disclaimer": "अस्वीकरण",
		"communication_preferences": {
			"title": "संचार वरीयताओं",
			"voice": "आवाज",
			"sms": "एसएमएस",
			"Whatsapp": "व्हाट्सएप"
		},
		"email_preferences": {
			"title": "ईमेल प्राथमिकताएं",
			"programRelated": "कार्यक्रम से संबंधित",
			"promotionalCampaigns": "प्रचार अभियान",
			"marketingMessages": "विपणन संदेश"
		},
		"notification_preferences": {
			"program related": "कार्यक्रम संबंधी",
			"reservations": "आरक्षण",
			"deals and promotions": "सौदा और प्रचार",
			"reminders": "अनुस्मारक"
		},
		"device_preferences": "डिवाइस वरीयताओं",
		"enableLock": "सक्षम अनुप्रयोग ताला",
		"staySignedIn": "प्रवेश किए हुए रहें",
		"message": "कृपया ध्यान दें कि हम आपकी सदस्यता की सेवा के लिए अधिसूचनाओं के माध्यम से लेन-देन संदेश भेजना जारी रखेंगे। लेन-देन संदेशों को अक्षम करने के लिए हम आपसे हमारे संपर्क केंद्र को कॉल करने का अनुरोध करते हैं।",
		"appVersion":"एप्लिकेशन वेरीज़न",
		"deleteAccount":"मेरा एकाउंट हटा दो"
	},
	"notifications": {
		"all_notifications": "सभी सूचनाएं",
		"message": "कृपया ध्यान दें कि हम आपकी सदस्यता की सेवा के लिए अधिसूचनाओं के माध्यम से लेन-देन संदेश भेजना जारी रखेंगे। लेन-देन संदेशों को अक्षम करने के लिए हम आपसे हमारे संपर्क केंद्र को कॉल करने का अनुरोध करते हैं।"
	},
	"contact_us": {
		"applied_text": "लागू",
		"connect_with_us": "हमारे साथ कनेक्ट",
		"help_desk": "संपर्क केंद्र",
		"emailMessage": "प्रिय टीम {{brandName}},",
		"emailSubject": "{{brandName}} मोबाइल ऐप %7c संपर्क करें",
		"give_a_missed_call": "मिस्ड कॉल दे",
		"connect_with_hotel": "के साथ कनेक्ट {{brandName}} सोशल मीडिया पर",
		"facebook": "फेसबुक",
		"google_plus": "गूगल प्लस",
		"instagram": "इंस्टाग्राम",
		"twitter": "ट्विटर",
		"whatsApp": "व्हाट्सएप"
	},
	"feedback": {
		"share_feedback": "प्रतिक्रिया साझा",
		"share_your_experience": "अपने अनुभव को साझा करें",
		"membership": "सदस्यता",
		"application": "आवेदन",
		"hotel": "होटल",
		"rate_feedback": "दर प्रतिक्रिया",
		"send_feedback": "प्रतिक्रिया भेजें",
		"go_to_home": "वापस जाने के लिए होम",
		"type_feedback": "प्रकार प्रतिक्रिया",
		"feedback_category": "प्रतिक्रिया श्रेणी",
		"alreadySubmitted": "आप पहले से ही प्रस्तुत किया प्रतिक्रिया. ठनक!",
		"rateAndShare": "दर और साझा करें अनुभव",
		"thankYouForFeedback": "आपकी प्रतिक्रिया के लिए धन्यवाद!",
		"weAreDelighted": "हम कर रहे हैं खुशी है कि आप एक महान अनुभव था और हम तत्पर हैं करने के लिए आप का स्वागत जल्द ही वापस.",
		"weWillShare": "हम अपनी प्रतिक्रिया साझा टीम के साथ और प्रेरित इस सब के सब करने के लिए हमें और भी बेहतर अगली बार.",
		"shareMemory": "एक स्मृति साझा",
		"shareFeedback": "प्रतिक्रिया साझा"
	},
	"faqs": {
		"Redemptions": "मोचन",
		"cancellations": "रद्दीकरण",
		"bookings": "बुकिंग",
		"MembershipRelated": "सदस्यता से संबंधित",
		"Offers": "घटनाओं, प्रस्तावों और प्रोन्नति",
		"Privacy": "डेटा और गोपनीयता नीति",
		"Gifting": "उपहार देने के",
		"Reservations": "आरक्षण"
	},
	"update_profile": {
		"title": "अद्यतन प्रोफ़ाइल",
		"your_profile_is": "अपने प्रोफ़ाइल है",
		"complete": "पूरा",
		"edit_profile": "बदलें फोटो",
		"change_password": "पासवर्ड बदलें",
		"add_nationality": "जोड़ें राष्ट्रीयता",
		"add_address": "पता जोड़ें",
		"add_landline_number": "लैंडलाइन नंबर जोड़ने",
		"add_loyalty_program": "जोड़ें वफादारी कार्यक्रम विवरण",
		"add_business_details": "व्यापार के विवरण को जोड़ने",
		"update_fav_hotel": "अद्यतन पसंदीदा होटल",
		"update_favourite_hotel": "अद्यतन अपने पसंदीदा होटल",
		"add_spouse_card": "जोड़ें जीवनसाथी कार्ड के विवरण",
		"spouse_card": "जीवनसाथी कार्ड",
		"activated": "सक्रिय",
		"celebratory_dates": "जश्न मनाने की तारीख",
		"name": "नाम",
		"relationship": "रिश्ते",
		"occasion": "अवसर",
		"date": "तारीख",
		"add_more_celebratory_date": "और अधिक जोड़ने के जश्न की तारीख",
		"your_preferences": "अपनी वरीयताओं",
		"language_preferences": "भाषा प्राथमिकताओं",
		"cuisine_preferences": "भोजन वरीयताओं",
		"lifestyle_preferences": "जीवन शैली वरीयताओं",
		"holiday_preferences": "छुट्टी वरीयताओं",
		"payment_settings": "भुगतान सेटिंग्स",
		"manage_saved_cards": "प्रबंधन कार्ड को बचाया",
		"delete": "हटाना",
		"add_another_card": "एक और कार्ड जोड़",
		"auto_payment_setup": "ऑटो भुगतान सेटअप",
		"monthly": "मासिक",
		"quarterly": "तिमाही",
		"annual": "वार्षिक",
		"select_payment_method": "भुगतान विधि का चयन करें",
		"preferred_currency": "पसंदीदा मुद्रा",
		"gst_details": "जीएसटी विवरण",
		"gold": "सोने",
		"other": "नाम के रिश्ते:",
		"otherOccassion": "नाम के अवसर का नाम:",
		"update": "अद्यतन",
		"got_it": "यह मिल गया",
		"update_hotel_request": "आपके अनुरोध अद्यतन किया जा रहा है और प्रतिबिंबित करेगा आपके सदस्यता खाते में 2 व्यावसायिक दिनों",
		"otherRelation": "अन्य संबंध",
		"otherOccassions": "अन्य अवसर"
	},
	"add_address": {
		"title": "पता जोड़ें",
		"addAddress": "पता जोड़ें",
		"editAddress": "पता संपादित करें",
		"address_type": "पता प्रकार",
		"select_address_type": "पते का चयन करें प्रकार",
		"country": "देश",
		"select_country": "देश का चयन करें",
		"address_line_1": "पता पंक्ति 1",
		"address_line_2": "पता पंक्ति 2",
		"city": "सिटी",
		"property": "प्रॉपर्टी",
		"select_city": "शहर का चयन करें",
		"pincode": "पिन कोड",
		"update": "अद्यतन",
		"add": "जोड़ें",
		"done": "किया",
		"hotel": "होटल",
		"level": "स्तर"
	},
	"add_business_details": {
		"title": "व्यापार के विवरण को जोड़ने",
		"addBusinessDetails": "व्यापार के विवरण को जोड़ने",
		"editBusinessDetails": "व्यापार के विवरण को संपादित",
		"designation": "पदनाम",
		"company_name": "कंपनी का नाम",
		"profession": "पेशे",
		"select_profession": "पेशे का चयन करें",
		"update": "अद्यतन"
	},
	"gst_details": {
		"title": "जीएसटी जोड़ें विवरण",
		"addGST": "जीएसटी जोड़ें विस्तार से",
		"editGST": "संपादित करें जीएसटी विस्तार से",
		"gst_number": "जीएसटी संख्या",
		"registered_company_name": "पंजीकृत कंपनी का नाम",
		"address_line_1": "पता पंक्ति 1",
		"address_line_2": "पता पंक्ति 2",
		"country": "देश",
		"select_country": "देश का चयन करें",
		"state": "राज्य",
		"select_state": "राज्य का चयन करें",
		"city": "शहर",
		"select_city": "शहर का चयन करें",
		"pincode": "पिन कोड",
		"update": "अद्यतन",
		"add_details": "विवरण जोड़ें"
	},
	"add_landline_number": {
		"title": "लैंडलाइन नंबर जोड़ने",
		"addLandline": "लैंडलाइन नंबर जोड़ने",
		"editLandline": "संपादित करें लैंडलाइन नंबर",
		"country_code": "देश कोड",
		"select_country_code": "देश कोड का चयन करें",
		"area_code": "क्षेत्र कोड",
		"select_area_code": "क्षेत्र कोड का चयन करें",
		"landline_number": "लैंडलाइन नंबर",
		"update": "अद्यतन"
	},
	"add_loyalty": {
		"title": "जोड़ें वफादारी कार्यक्रम विवरण",
		"addLoyalty": "जोड़ें वफादारी कार्यक्रम विवरण",
		"editLoyalty": "संपादित वफादारी कार्यक्रम विवरण",
		"program_name": "कार्यक्रम का नाम",
		"select_a_program": "एक प्रोग्राम का चयन",
		"membership_number": "सदस्यता संख्या",
		"delete": "हटाना",
		"add_more": "और अधिक जोड़ने",
		"update": "अद्यतन"
	},
	"add_nationality": {
		"title": "जोड़ें राष्ट्रीयता",
		"addNationality": "जोड़ें राष्ट्रीयता",
		"editNationality": "संपादित करें राष्ट्रीयता",
		"nationality": "राष्ट्रीयता",
		"select_nationality": "का चयन राष्ट्रीयता",
		"update": "अद्यतन"
	},
	"add_spouse_card": {
		"title": "जोड़ें जीवनसाथी विवरण"
	},
	"edit_email_mobile": {
		"update_email": "अपडेट ईमेल आईडी",
		"update_mobile": "अद्यतन मोबाइल नंबर",
		"enter_otp": "Enter OTP में नीचे अनुभाग",
		"enter_otp_email": "कृपया अपने ईमेल पर भेजा गया ओटीपी दर्ज करें।",
		"enter_otp_mobile": "कृपया अपने मोबाइल पर भेजे गए ओटीपी को दर्ज करें।"
	},
	"new_celebratory": {
		"addCelebratory": "जोड़ने के जश्न की तारीख",
		"editCelebratory": "संपादित जश्न की तारीख"
	},
	"giftMembership": {
		"title": "उपहार एक सदस्यता",
		"country": "देश",
		"city": "शहर",
		"hotel": "होटल",
		"level": "स्तर",
		"promo": "प्रोमो कोड",
		"proceed": "आगे बढ़ने के लिए उपहार",
		"giftMembership": "सदस्यता उपहार",
		"upgradeMembership": "सदस्यता का उन्नयन",
		"renew_Membership": "सदस्यता को नवीनीकृत",
		"invalidPromoCode": "अमान्य Promcode या रेफरल कोड",
		"withoutPromo": "के बिना आगे बढ़ना प्रोमो कोड",
		"retry_button": "पुन: प्रयास करें प्रोमो कोड"
	},
	"giftDetail": {
		"title": "उपहार विस्तार से",
		"details": "दर्ज नाम और संपर्क विवरण",
		"firstName": {
			"required": "पहला नाम आवश्यक है",
			"pattern": "अमान्य नाम"
		},
		"lastName": {
			"required": "अंतिम नाम आवश्यक है",
			"pattern": "अमान्य अंतिम नाम"
		},
		"email": {
			"required": "ईमेल आवश्यक है",
			"pattern": "कृपया मान्य ईमेल दर्ज करें"
		},
		"mobile": {
			"required": "मोबाइल की आवश्यकता है",
			"pattern": "मान्य मोबाइल नंबर दर्ज करें",
			"validPhoneNumber": "मान्य मोबाइल नंबर दर्ज करें!"
		},
		"gstOptional": "जीएसटी की जानकारी(वैकल्पिक)",
		"gstNumber": "जीएसटी संख्या दर्ज करें",
		"gstCompany": "पंजीकृत कंपनी का नाम",
		"payNow": "अब भुगतान",
		"proceesdNow": "आगे बढ़ें",
		"requestActivation": "अनुरोध सक्रियण",
		"payment_title": "आपका भुगतान सफल रहा है और लेन-देन की संख्या है {{transactionNumber}}.",
		"payment_title_without_transaction": "आपका भुगतान सफल है । ",
		"payment_para": "एक पुष्टिकरण ईमेल और एसएमएस के लिए भेजा गया है {{giftedMemberFirstName}} {{giftedMemberLastName}} के साथ विवरण को सक्रिय करने के लिए सदस्यता के साथ, अपने संदेश के साथ.",
		"uploading_video": "वीडियो अपलोड हो रहा है",
		"giftNow": "अभी उपहार दें",
		"choosePreferredDateAndTime": "पसंदीदा तिथि और समय चुनें",
		"preferredDate": "वरीय तिथि",
		"preferredTimeZone": "वरीय तिथि ({{timeZone}})",
		"hours": "{{hours}} घंटे"
	},
	"searchOutlet": {
		"search": "खोज एक ",
		"reserve": "का चयन करें",
		"redeem": "का चयन करें",
		"book": "का चयन करें",
		"request": "एक आरक्षण अनुरोध",
		"resturant": "खोज एक रेस्तरां",
		"hotel": "एक होटल का चयन करें",
		"pool": "एक स्विमिंग पूल का चयन करें",
		"spa": "एक स्पा का चयन करें",
		"other": "एक दुकान का चयन करें",
		"gym": "एक जिम का चयन करें",
		"proceed": "आगे बढ़ें",
		"searchOutlets": "आउटलेट खोजें"
	},
	"outletDetail": {
		"menu": "दृश्य मेनू",
		"benefit": " लाभ उपलब्ध",
		"certificate": "प्रमाणपत्र के लाभ",
		"card": "कार्ड लाभ",
		"menuImage": "मेनू छवि",
		"close": "करीब",
		"description": "सभी का आनंद-दिन ठीक भोजन में यहाँ बैंगलोर में जेडब्ल्यू रसोई. हमारे अंतरराष्ट्रीय स्तर पर प्रेरित restaurent प्रदान करता है एक ला कार्टे मेनू के 24 घंटे एक दिन, deliecious बुफे, और एक प्रशस्त रविवार ब्रंच.",
		"dine": "मेहमानों की सराहना की महाराज पर",
		"stay": "मेहमानों की सराहना की हमारे आवास पर",
		"spa": "मेहमानों की सराहना की हमारे स्पा सेवाओं पर",
		"pool": "मेहमानों की सराहना की हमारी पूल सेवाओं पर",
		"cardBenefit": "कार्ड लाभ",
		"restaurant": "रेस्तरां",
		"Pool": "पूल",
		"accomodation": "निवास",
		"Spa": "स्पा",
		"appDine": "डाइन",
		"reviews": "Reviews"
	},
	"certificateDetails": {
		"title": "प्रमाण पत्र विवरण",
		"cardTitle": "कार्ड के विवरण",
		"redeem": "के एवज में",
		"reserve": "रिजर्व",
		"book": "पुस्तक",
		"gift": "उपहार प्रमाण पत्र",
		"add_to_Gift_cart": "जोड़ने के लिए उपहार टोकरी",
		"add_to_cart": "कार्ट में जोड़ें",
		"valid": "वैध माध्यम से",
		"stayDescription": "आप अब हो जाएगा करने के लिए पुनः निर्देशित {{brandURL}} प्रक्रिया के लिए अपने आरक्षण के लिए अनुरोध. दर्ज करें कॉर्पोरेट प्रोमो कोड MZ7 धारा के तहत 'विशेष दरों का लाभ उठाने के लिए इस सदस्यता लाभ है । आप की आवश्यकता होगी करने के एवज में इस प्रमाण पत्र के समय पर आगमन पर होटल.",
		"downloadApp": "डाउनलोड {{brandName}} अनुप्रयोग",
		"site": "मुझे लेने के लिए",
		"call": "अब कॉल करें",
		"archieve": "प्रमाणपत्र संग्रहीत सफलतापूर्वक",
		"unarchieve": "प्रमाण पत्र Unarchieved सफलतापूर्वक",
		"resendGift": "प्रमाण-पत्र पुनः भेंट सफलतापूर्वक"
	},
	"cart": {
		"title": "गाड़ी"
	},
	"membershipBenefit": {
		"title": "सदस्यता लाभ",
		"noCard": "कोई कार्ड के लाभ उपलब्ध",
		"noCertificate": "खरीदें उच्च मूल्य प्रमाण पत्र",
		"validbenefit": "पर मान्य भाग लेने वाले सभी मैरियट होटल",
		"noCertificateWithoutAction": "आपके पास कोई प्रमाण पत्र नहीं है। आप एक सदस्यता या प्रमाण पत्र खरीद सकते हैं।"
	},
	"dinningReservation": {
		"title": "आरक्षण",
		"update": "अद्यतन आरक्षण",
		"at": "पर",
		"treatment": "का चयन करें उपचार",
		"therapy": "चिकित्सा",
		"beauty": "सौंदर्य उपचार",
		"other": "अन्य",
		"preferredDate": "चुनें पसंदीदा तारीख",
		"today": "आज",
		"tommorrow": "कल",
		"preferredTime": "चुनें पसंदीदा समय",
		"duration": "अवधि का चयन करें",
		"guestNumber": "का चयन मेहमानों की संख्या",
		"adultNumber": "का चयन करें वयस्कों की संख्या",
		"kidNumber": "का चयन बच्चों की संख्या",
		"celebration": "अधिक हमें बताओ के बारे में अपने उत्सव",
		"birthday": "जन्मदिन",
		"anniversary": "शादी की सालगिरह",
		"foodPreference": "जोड़ने के भोजन वरीयताओं",
		"beveragePreference": "पेय जोड़ वरीयताओं",
		"specialRequest": "विशेष अनुरोध",
		"termsStatement": "मैं के साथ सहमत ",
		"termsAndCondition": "नियम और शर्तें ",
		"conditionStatement": "के लाभ",
		"confirmReservation": "आरक्षण की पुष्टि",
		"requestReservation": "आरक्षण का अनुरोध करें",
		"back": "वापस",
		"cont": "जारी",
		"got_it": "यह मिल गया",
		"call_Now": "अब कॉल करें",
		"continue": "जारी आरक्षण",
		"certificate_validation": "इस लाभ उपलब्ध नहीं है, पर चयनित तिथि या समय । की जाँच करें उपयोग की शर्तों के साथ इस लाभ. आप वापस जा सकते हैं या जारी रखने के लिए इस के बिना लाभ.",
		"two_time_validation": "हम करने में असमर्थ हैं, इस प्रक्रिया का अनुरोध. आप कॉल कर सकते हैं आउटलेट के साथ बात करने के लिए उन्हें सीधे.",
		"valid_time_validation": "आउटलेट परिचालन नहीं है इन घंटे के दौरान. का चयन करें एक वैकल्पिक समय का चयन करें या एक और दुकान । ",
		"restricted_time_validation": "हम करने में असमर्थ हैं, इस बात की पुष्टि आरक्षण ऑनलाइन. आप कॉल कर सकते हैं आउटलेट या आगे बढ़ने के साथ आरक्षण के लिए अनुरोध. आउटलेट करेगा आपके अनुरोध की समीक्षा और आप के लिए वापस पाने में 24 घंटे.",
		"guest_validation": "इस लाभ के लिए ही मान्य है की एक अधिकतम के साथ दो मेहमानों के लिए. हो सकता है आप आगे बढ़ना है और बसने की अतिरिक्त राशि सीधे प्रस्थान पर.",
		"guestCountMinValidation": "इस लाभ के लिए ही मान्य है की एक न्यूनतम {{count}} अतिथि(एस). हो सकता है आप आगे बढ़ना है और बसने की अतिरिक्त राशि सीधे प्रस्थान पर.",
		"guestCountMaxValidation": "इस लाभ के लिए ही मान्य है की एक अधिकतम {{count}} अतिथि(एस). हो सकता है आप आगे बढ़ना है और बसने की अतिरिक्त राशि सीधे प्रस्थान पर.",
		"guest_vali": "हम करने में असमर्थ हैं, इस बात की पुष्टि आरक्षण ऑनलाइन. आप कॉल कर सकते हैं आउटलेट या आगे बढ़ने के साथ आरक्षण के लिए अनुरोध. आउटलेट करेगा आपके अनुरोध की समीक्षा और आप के लिए वापस पाने में 24 घंटे.",
		"cancelReservationWhileModification": "कृपया ध्यान दें कि इस प्रमाण पत्र उपलब्ध नहीं है के दौरान चयनित तिथि या समय । की जाँच करें उपयोग की शर्तें इस के लाभ के लिए. कृपया वापस जाने के लिए और संशोधन इस आरक्षण या रद्द इस आरक्षण और एक नए सिरे से आरक्षण.",
		"selectDuration": "अवधि",
		"tellUsMore": "आप चाहते हैं हमें बताने के लिए और अधिक ?",
		"guest": "अतिथि के लिए",
		"guests": "अतिथि",
		"adult": "वयस्क",
		"adults": "वयस्क",
		"kid": "बच्चे",
		"kids": "बच्चे",
		"pleaseSelectFutureDateTime": "कृपया भविष्य की तारीख / समय चुनें।"
	},
	"staticMessages": {
		"success": "सफलता । ",
		"error": "कुछ गलत हो गया था.",
		"genricErrorMessage": "हम आपके {{brand Name}} ऐप अनुभव को अनुकूलित कर रहे हैं।"
	},
	"redeemBenefit": {
		"title": "के एवज में लाभ",
		"titleGift": "उपहार प्रमाण पत्र",
		"property": "रेस्तरां का नाम",
		"guest": "अतिथि के लिए",
		"adult": "वयस्क",
		"kid": "बच्चे",
		"proceedToCheckIn": "आगे बढ़ने के लिए में जाँच करें",
		"checkIn": "करने के लिए आगे बढ़ने के एवज में",
		"spaModal": "कृपया एवज में लाभ स्पा में.",
		"stayModal": "इस लाभ के अधीन है करने के लिए एक कमरे की पुष्टि की आरक्षण के रूप में एक ही कमरे के रूप में श्रेणी के अनुसार मामले के लाभ के लिए. कृपया एवज में इस लाभ के बाद में जाँच करने के लिए होटल.",
		"dineModal": "कृपया एवज में लाभ के बाद ही आप बैठा दिया गया है. आप की जरूरत हो सकता है पेश करने के लिए एक फोटो आईडी लाभ उठाने के लिए लाभ.",
		"poolModal": "कृपया एवज में लाभ स्विमिंग पूल में.",
		"gotIt": "यह मिल गया",
		"proceed": "आगे बढ़ना",
		"redeemptionErrorForTime": "मोचन केवल किया जा सकता है के बीच एक घंटे पहले और बाद के समय आरक्षण. धन्यवाद.",
		"outletName": "आउटलेट का नाम",
		"admit": "स्वीकार करना"
	},
	"redeemBenefitOTP": {
		"title": "के एवज में लाभ",
		"subTitle": "मुक्ति लाभ",
		"codePopulate": "कोड होगा ऑटो-बसा 3 सेकंड में",
		"trouble": "मुसीबत के साथ OTP? ",
		"scan": " स्कैन QR कोड",
		"confirm": "इस बात की पुष्टि",
		"giftcertifcate": "उपहार प्रमाण पत्र..",
		"giftto": "उपहार के लिए",
		"otp": "OTP भेजा जाएगा करने के लिए अपने पंजीकृत मोबाइल नंबर."
	},
	"redeemBenefitQR": {
		"title": "के एवज में लाभ",
		"qrCode": "क्यूआर कोड को दिखाने के लिए स्क्रीन पर प्रमाण पत्र के एवज में ",
		"troubleWithQR": "मुसीबत withe qr कोड ? दे कृपया अपनी सदस्यता संख्या और प्रमाण पत्र के विवरण आप चाहते हैं के लिए एवज में होटल के कर्मचारियों के लिए. आप एक एसएमएस मिलेगा और और एक ईमेल की पुष्टि मोचन",
		"done": "किया",
		"regenerate_para": "पर क्लिक करें बटन को पुनर्जीवित करने के लिए उत्पन्न नई क्यूआर कोड",
		"regenerate": "पुनर्जन्म"
	},
	"redeemBenefitCertificate": {
		"title": "के एवज में लाभ",
		"benefit": "लाभ छुड़ाया",
		"certificate": "प्रमाण पत्र कोड",
		"certificateName": "प्रमाण - पत्र नाम",
		"confirmation": "आप एक एसएमएस प्राप्त होगा और एक ईमेल के रूप में पुष्टि",
		"create_a_memory": "एक स्मृति बनाने",
		"Membership Number": "सदस्यता संख्या",
		"Transaction Number": "लेन-देन की संख्या"
	},
	"redeemBenefitRating": {
		"title": "प्रतिक्रिया देने के",
		"experience": "अपने अनुभव का मूल्यांकन",
		"compliment": "बधाई महाराज",
		"review": "समीक्षा",
		"submit": "प्रस्तुत",
		"share": "शेयर पर यात्रा सलाहकार",
		"reviewCheckboxContent": "मैं {{brandName}} को इस समीक्षा को साझा करने की अनुमति देता हूं।"
	},
	"tableReserve": {
		"title": "आरक्षण सारांश",
		"reserve": "आरक्षण की पुष्टि की है!",
		"poolrequest": "आरक्षण का अनुरोध किया है!",
		"dinetable": "मेज आरक्षित!",
		"confirmation": "पुष्टिकरण संख्या",
		"requestNumber": "अनुरोध संख्या",
		"wallet": "+ जोड़ें करने के लिए बटुआ",
		"calender": "+ कैलेंडर में जोड़ें",
		"addTo": "Add to",
		"appleWallet": "Apple Wallet",
		"redeem": "के एवज में ",
		"poolSpa": "अपने लाभ को भुनाने के लिए होटल के कर्मचारियों के पास अपने आगमन की घोषणा करें। हम अपेक्षित आगमन समय पर 15 मिनट के लिए आपकी टेबल को रोके रखेंगे। आपके आरक्षण और वरीयताओं के विवरण के साथ आपको एक ईमेल भेजा गया है।",
		"reservation": "अपने आरक्षण वरीयताओं",
		"celebration": "उत्सव",
		"food": "भोजन वरीयताओं",
		"beverage": "पेय वरीयताओं",
		"request": "विशेष अनुरोध",
		"chef": "के साथ कनेक्ट हमारे महाराज",
		"invite": "चाहते हैं करने के लिए मेहमानों को आमंत्रित?",
		"sendInvite": "आमंत्रण भेजें",
		"assistance": "सहायता की जरूरत है होटल में?",
		"cancel": "रद्द",
		"modify": "संशोधित",
		"home": "जाने के लिए घर पृष्ठ",
		"inviteDescription": "आप भेज सकते हैं व्यक्तिगत आमंत्रित किया है करने के लिए अपने सभी मेहमानों के साथ आरक्षण के विवरण में शामिल होने के लिए आप स्थल पर.",
		"delete_reservation": "आरक्षण रद्द",
		"delete_reservation_para": "कर रहे हैं आप सुनिश्चित करें कि आप रद्द करना चाहते हैं इस आरक्षण ?",
		"yes": "हाँ",
		"no": "कोई",
		"January": "जनवरी",
		"February": "फरवरी",
		"March ": "मार्च ",
		"April": "अप्रैल",
		"May": "मई",
		"June": "जून",
		"July": "जुलाई",
		"August": "अगस्त",
		"September": "सितंबर",
		"October": "अक्टूबर",
		"November": "नवंबर",
		"December": "दिसंबर",
		"Monday": "सोमवार",
		"Tuesday": "मंगलवार",
		"Wednesday": "बुधवार",
		"Thursday": "गुरूवार",
		"Friday": "शुक्रवार",
		"Saturday": "शनिवार",
		"Sunday": "रविवार",
		"contact": "संपर्क करें"
	},
	"tabsMembership": {
		"membershipTitle": "मेरी सदस्यता",
		"termsOfUse": "उपयोग की शर्तें",
		"certificateTitle": "मेरे प्रमाण पत्र",
		"certificateListTitle": "का चयन करें प्रमाण पत्र के लिए उपहार",
		"upgradeMembershipTitle": "अपनी सदस्यता का उन्नयन",
		"historyTitle": "इतिहास",
		"specialOfferTitle": "मेरे विशेष ऑफर",
		"viewAll": "सभी देखें",
		"view": "देखें",
		"cardsWallet": "कार्ड बटुआ",
		"pointsTitle": "अंक",
		"validThru": "वैध माध्यम से",
		"ecashCertificateTitle": "अनुभव प्रमाण पत्र",
		"certificateTypes": {
			"dining": "भोजन",
			"spa": "स्पा",
			"pool": "पूल",
			"luxuryStay": "रहने",
			"health": "स्वास्थ्य",
			"other": "अन्य"
		},
		"special": "विशेष पेशकश",
		"for_other": "प्रमाण पत्र से भागीदार लाभ जल्द ही आ रहा है.",
		"receiveGiftCertificate": "लाभ प्राप्त करने के लिए कोड दर्ज करें",
		"viewBenefitTerms": "View Benefits and Terms"
	},
	"cardBenefit": {
		"cardBenefitsTitle": "कार्ड लाभ",
		"validThru": "वैध माध्यम से",
		"termsCondition": "टी एंड सी",
		"since": "के बाद से",
		"validAt": "पर मान्य",
		"reserve": "रिजर्व",
		"redeem": "के एवज में",
		"book": "पुस्तक",
		"certificateTypes": {
			"dining": "भोजन",
			"spa": "स्पा",
			"pool": "पूल",
			"luxuryStay": "रहने",
			"health": "स्वास्थ्य",
			"other": "अन्य"
		},
		"terms": "टी एंड सी",
		"termsAndContion": "कार्ड के नियम और शर्तों"
	},
	"loader": {
		"globalMsgWait": "कृपया प्रतीक्षा करें..",
		"globalMsgLoad": "लोड हो रहा है..",
		"fetchData": "कृपया प्रतीक्षा करें..",
		"uploadImage": "छवि अपलोड करने के..",
		"uploadVideo": "वीडियो अपलोड..",
		"login": "लॉगिंग में..",
		"profile": "दिलकश प्रोफ़ाइल डेटा..",
		"updateProfile": "अद्यतन प्रोफ़ाइल डेटा..",
		"updatingDefault": "अद्यतन..",
		"logout": "लॉगिंग आप बाहर",
		"validatePromo": "मान्य प्रोमो कोड...",
		"activityLoadMsg": "लोड हो रहा है गतिविधियों...",
		"sendingOtp": "भेजने OTP...",
		"verifyingOtp": "पुष्टि करने OTP...",
		"verifyEmail": "सत्यापन ईमेल...",
		"verifyMobile": "पुष्टि करने के मोबाइल...",
		"unlockBenefit": "कृपया प्रतीक्षा करें..",
		"online": "अब आप ऑनलाइन हैं",
		"offline": "अब आप ऑफ़लाइन हैं"
	},
	"toastMsg": {
		"imgUploadFail": "छवि अपलोड करने में विफल रहा है.",
		"imageUploadSucc": "छवि अपलोड सफलतापूर्वक । ",
		"checkInternet": "कृपया इंटरनेट से कनेक्ट करने के लिए एप्लिकेशन का उपयोग करें",
		"mobileAlreadyExist": "मोबाइल नंबर में प्रवेश किया, पहले से ही मौजूद है । आप का अनुरोध करने के लिए लॉगिन करें.",
		"emailAlreadyExist": "ईमेल आईडी में प्रवेश किया, पहले से ही मौजूद है । आप का अनुरोध करने के लिए लॉगिन करें.",
		"dearGuest": "प्रिय मेहमान,",
		"enter_valid_email": "वैध ईमेल आईडी दर्ज करें!",
		"enter_email_or_mobile": "कृपया मोबाइल नंबर दर्ज करें या ईमेल आईडी करने के लिए आगे बढ़ना!",
		"enterMobile": "कृपया मोबाइल नंबर दर्ज करें करने के लिए आगे बढ़ना!",
		"enterEmail": "दर्ज करें एक ईमेल आईडी करने के लिए आगे बढ़ना!",
		"otpToProceed": "कृपया enter otp के लिए आगे बढ़ना!",
		"requestOtp": "कृपया अनुरोध एक OTP करने के लिए आगे बढ़ें । ",
		"somethingWrong": "कुछ गलत हो गया था.",
		"validPromo": "कृपया एक मान्य प्रोमो कोड.",
		"profileMobileExist": "मोबाइल नंबर पहले से ही मौजूद है । कृपया प्रवेश के लिए एक अलग मोबाइल नंबर.",
		"profileEmailExist": "ईमेल पहले से मौजूद है. कृपया प्रवेश के लिए एक अलग ईमेल.",
		"initApp": "प्रारंभिक एप्लिकेशन",
		"videoError": "आप 50mb से अधिक अपलोड नहीं कर सकते",
		"ok": "ठीक है",
		"invalidPromo": "This Promo Code is not valid",
		"busyMicrophone": "Unable to access Microphone. It may be in use by some other application.",
		"unableAccessMicrophone": "No audio received. Please check your microphone and try again."
	},
	"otp": {
		"requestOTP": "अनुरोध OTP",
		"resendOTP": "पुन: भेजें OTP",
		"mobileOtpMessage": "आपके मोबाइल नंबर पर एक OTP भेजा गया है",
		"emailOtpMessage": "आपके ईमेल पर एक OTP भेजा गया है"
	},
	"chat": {
		"ChatSucuss": "हमने आपके अनुरोध पर ध्यान दिया है। हमारे सदस्यता विशेषज्ञ 24 घंटे के भीतर आपसे संपर्क करेंगे।",
		"ChatSucussHeader": "अनुरोध सबमिट किया गया।",
		"chatUnavailable": "धन्यवाद से संपर्क करने के लिए {{brandName}} केंद्र से संपर्क करें. हमारे सभी चैट के अधिकारी कर रहे हैं वर्तमान में व्यस्त है । आप फिर से कोशिश कर सकते में कुछ समय के लिए, पर हमें फोन 18001021030 या पर हमें ईमेल {{careURL}}.",
		"chatTime": "धन्यवाद से संपर्क करने के लिए {{brandName}} केंद्र से संपर्क करें. हमारे लाइव सहायता से उपलब्ध है 9:00 बजे से 9:00 PM IST. आप पर हमें ईमेल कर सकते {{careURL}}."
	},
	"sendInvite": {
		"title": "मेहमानों को आमंत्रित",
		"subTitle": "आमंत्रित अपने मेहमानों को इस घटना के लिए",
		"oldSub": "निमंत्रण भेजने के लिए अपने मेहमानों के लिए सेवा पर hotelName पर तारीख, एक",
		"numberOfInviteSent": "निमंत्रण भेजा!",
		"oneInviteSent": "आमंत्रित भेजा!",
		"modalPara": " अपने भोजन का आनंद लें के साथ अपने मेहमानों पर hotelName पर एक तारीख",
		"modalbutton": "यह मिल गया",
		"button": "शेयर को आमंत्रित करें",
		"addMore": "और अधिक जोड़ने",
		"at": "पर"
	},
	"planWith": {
		"title": "योजना के साथ {{hotelName}}",
		"travelExperiences": "यात्रा के अनुभवों",
		"country": "देश",
		"city": "शहर",
		"property": "होटल",
		"numberOfGuest": "मेहमानों की संख्या",
		"hours": "घंटे",
		"minutes": "मिनट",
		"signatureDishes": "हमारे हस्ताक्षर व्यंजन के लिए सुरक्षित प्रसव"
	},
	"socialEvents": {
		"title": "सामाजिक घटनाओं",
		"selectSocialEvent": "का चयन सामाजिक घटना",
		"numberOfGuest": "का चयन मेहमानों की संख्या",
		"selectDate": "तिथि का चयन",
		"selectTime": "समय का चयन करें",
		"submit": "प्रस्तुत",
		"moreAboutCelebration": "अधिक हमें बताओ के बारे में अपने उत्सव",
		"selectCountryLabel": "देश",
		"selectPropertyLabel": "होटल",
		"selectCityLabel": "शहर",
		"selectCountry": "देश का चयन करें",
		"selectCity": "शहर का चयन करें",
		"selectProperty": "होटल का चयन करें",
		"selectLevel": "स्तर का चयन करें",
		"datesAreFlexible": "दीपावली लचीला कर रहे हैं",
		"gotIt": "यह मिल गया",
		"hotelWillContactYouIn24": "{{hotelName}} के साथ कनेक्ट करेगा, आप के भीतर 24 घंटे के व्यापार."
	},
	"businessMeeting": {
		"title": "व्यापार बैठकों",
		"selectMeeting": "का चयन करें प्रकार बैठक",
		"moreAboutConference": "हमें बताओ के बारे में अधिक अपने सम्मेलन",
		"am": "हूँ",
		"pm": "PM"
	},
	"activitiesHub": {
		"title": "गतिविधियों का केंद्र",
		"connectToKnowMore": "कनेक्ट करने के लिए और अधिक जानना",
		"contactMessage": "{{brandName}} संपर्क करेंगे । धन्यवाद.",
		"buttonText": "किया"
	},
	"personalServices": {
		"title": "व्यक्तिगत सेवाएँ"
	},
	"cancelReservation": {
		"title": "आरक्षण रद्द कर दिया",
		"cancellation": "रद्द करने की संख्या",
		"info": "इस आरक्षण को रद्द कर दिया गया है . अगर इस आरक्षण नहीं किया गया है रद्द कर दिया गया आप के द्वारा कृपया हमसे संपर्क करें । "
	},
	"reactivate_Membership": {
		"upgrade": "नवीनीकरण सदस्यता",
		"view_benefit": "देखने के लाभ",
		"renew_membership": "सदस्यता नवीनीकृत",
		"reactivate_membership": "सदस्यता को पुन: सक्रिय",
		"level_Benefits": "स्तर लाभ",
		"payment": "आपका भुगतान सफल है!",
		"renew_Payment_without_transaction": "आपका भुगतान सफल है । नए सिरे से सदस्यता लाभ कर रहे हैं पर देखने के लिए उपलब्ध अपने सदस्यता पृष्ठ.",
		"reactivate_Payment_without_transaction": "आपका भुगतान सफल है । अद्यतन लाभ कर रहे हैं पर देखने के लिए उपलब्ध अपने सदस्यता पृष्ठ.",
		"renew_Payment": "आपका भुगतान सफल रहा है और लेन-देन की संख्या है {{transactionNumber}}. नए सिरे से सदस्यता लाभ कर रहे हैं पर देखने के लिए उपलब्ध अपने सदस्यता पृष्ठ.",
		"reactivate_Payment": "आपका भुगतान सफल रहा है और लेन-देन की संख्या है {{transactionNumber}}. अद्यतन लाभ कर रहे हैं पर देखने के लिए उपलब्ध अपने सदस्यता पृष्ठ.",
		"featureDisabled": "इस सुविधा को अक्षम किया गया है के लिए एप्लिकेशन के बीटा संस्करण",
		"renewal_benefits": "नवीकरण के लाभ",
		"reactivation_benefits": "पुन: सक्रियण लाभ"
	},
	"partnerBenefit": {
		"title": "साथी के लाभ",
		"select": "चयन करें"
	},
	"activitiesTab": {
		"title": "गतिविधियों",
		"upcomingReservation": "आगामी आरक्षण",
		"noUpcomingReservation": "कोई आगामी आरक्षण",
		"startDate": "शुरू करने की तारीख",
		"endDate": "के अंत की तारीख",
		"activityHistory": "गतिविधि इतिहास",
		"noActivitiesFound": "कोई गतिविधि का इतिहास!",
		"certificateLabel": "प्रमाण पत्र",
		"amount": "राशि",
		"certificateNumber": "प्रमाण पत्र संख्या",
		"transactionNumber": "लेन-देन की संख्या",
		"certificateBenefitLabel": "प्रमाणपत्र के लाभ",
		"numberOfPoints": "अंकों की संख्या",
		"promocode": "प्रोमो कोड",
		"outletAndProperty": "आउटलेट और संपत्ति",
		"amountSpent": "खर्च की गई राशि",
		"memberhsipTypeLabel": "सदस्यता के प्रकार",
		"outletLabel": "आउटलेट",
		"benefitAvailed": "लाभ का लाभ उठाया",
		"pointsEarned": "अंक अर्जित",
		"cancellationNumber": "रद्द करने की संख्या",
		"redemptionCodeLabel": "मोचन कोड",
		"feedbackGiven": "प्रतिक्रिया दी",
		"profileUpdated": "प्रोफ़ाइल अद्यतन",
		"membershipExpiryDate": "सदस्यता समाप्ति की तारीख",
		"numberOfPointsRedeemed": "संख्या के अंक भुनाया",
		"membershipNumber": "सदस्यता संख्या",
		"certificateExpiryDate": "प्रमाण पत्र की समाप्ति की तारीख",
		"membershipTypeLabel": "सदस्यता के प्रकार",
		"at": "पर",
		"showMore": "दिखाने के और अधिक",
		"showLess": "कम",
		"viewCheque": "देखें चेक",
		"feedbackDetails": "प्रतिक्रिया विवरण",
		"rating": "रेटिंग"
	},
	"orderIn": {
		"title": "आदेश में",
		"country": "देश",
		"selectCountry": "देश का चयन करें",
		"searchCityHotelRestaurant": "खोज शहर से, होटल या रेस्तरां में",
		"noResultFound": "कोई परिणाम नहीं पाया!",
		"viewDetails": {
			"title": "भोजन",
			"openFrom": "से खुला",
			"discountAvailable": "डिस्काउंट पर उपलब्ध है आदेश में",
			"guestApplaud": "मेहमानों apploaded महाराज पर "
		}
	},
	"cardWallet": {
		"buyAnotherMembership": "एक और खरीदने की सदस्यता",
		"noMembershipPresent": "कोई सदस्यता संख्या मौजूद",
		"selectHotel": "होटल का चयन करें",
		"pleaseEnterPromocode": "कृपया एक मान्य प्रोमो कोड",
		"pleaseApplyPromocode": "Please Apply the valid promocode!",
		"update": "अद्यतन सदस्यता",
		"buyAnother": "एक सदस्यता खरीदें",
		"giftMessage": "उपहार संदेश",
		"giftCardReceiver": "उपहार कार्ड रिसीवर",
		"membershipViewGiftMessage": "उपहार संदेश देखें",
		"membershipGiftReceived": "उपहार मिला"
	},
	"buyAnotherMembership": {
		"new_membership": "आपका भुगतान सफल रहा है और लेन-देन की संख्या है {{transactionNumber}}. सदस्यता पर उपलब्ध है अपनी सदस्यता पृष्ठ के तहत कार्ड बटुआ.",
		"new_membership_without_transaction": "आपका भुगतान सफल है । सदस्यता पर उपलब्ध है अपनी सदस्यता पृष्ठ के तहत कार्ड बटुआ.",
		"errorPurchase": "लगता है अपने कुल खरीद राशि से भी अधिक से अधिक {{maxPayableAmount}}. हम आप का अनुरोध करने के लिए, कृपया संपर्क हमारे ग्राहक देखभाल करने के लिए की खरीद के लिए राशि की तुलना में अधिक {{maxPayableAmount}}. धन्यवाद!"
	},
	"ecash": {
		"title": "अनुभव प्रमाण पत्र",
		"chooseECashCertificate": "कृपया अनुभव सर्टिफिकेट चुनें क्योंकि आपने अनुभव प्रमाण पत्र के लिए जाँच की थी!"
	},
	"logout": {
		"title": "लॉगआउट!",
		"message": "आप सुनिश्चित हैं कि आप चाहते हैं करने के लिए लॉगआउट?",
		"no": "कोई",
		"yes": "हाँ"
	},
	"referralFriend": {
		"referalCode": "अपने रेफरल कोड",
		"referalShare": "साझा करें",
		"referalCopy": "कॉपी",
		"referalwork": "यह कैसे काम करता है",
		"referalView": "देखें और अपने रेफरल कोड",
		"referalViewStatus": "अपने रेफरल कोड",
		"referalConversions": "रूपांतरण",
		"referalCertificate": "प्रमाण पत्र(एस) से जोड़ा रेफरल में देखा जा सकता है '' मेरी सदस्यता स्क्रीन",
		"referalcash": "अनुभव प्रमाणपत्रप्राप्त",
		"referalSharePlease": "कृपया अपने रेफरल कोड के साथ ही लोग हैं, जो कर सकते हैं से लाभ {{brandName}} सदस्यता.",
		"referalCopyClip": "कोड आपके क्लिपबोर्ड पर नकल की",
		"referalMonth": "जनवरी,फरवरी,मार्च,अप्रैल,मई,जून,जुलाई,अगस्त,सितंबर,अक्टूबर,नवंबर,दिसंबर",
		"referalHeader": "एक दोस्त के संदर्भ लें",
		"referalShareMessage": "लिंक {{websiteURL}} का उपयोग करके ऐप डाउनलोड करके {{brandName}} सदस्य बनें और {{currentBrand}} होटलों पर रोमांचक लाभ उठाएं। सदस्यता शुल्क पर 10 प्रतिशत छूट का आनंद लेने के लिए रेफरल कोड का उपयोग करें। ऐप पर {{brandName}} सदस्यता के लिए साइन अप करते समय एक प्रोमो कोड दर्ज करने के लिए संकेत दिए जाने पर यह कोड दर्ज करें।",
		"btnGift": "उपहार",
		"btnKeepwithMe": "मेरे साथ रहो",
		"updatedSuccessfully": "अद्यतन सफलतापूर्ण हो गया"
	},
	"giftCertificate": {
		"Proceed": "आगे बढ़ने के लिए उपहार",
		"Add": "+ और अधिक जोड़ने",
		"cart": "गाड़ी",
		"selectGift": "का चयन करें प्रमाण पत्र के लिए उपहार",
		"buyGift": "खरीदें उच्च मूल्य प्रमाण पत्र",
		"contactDetailsGift": "दर्ज नाम और संपर्क विवरण",
		"wordsGift": "100 शब्दों",
		"titlecount": "प्रमाण पत्र मायने रखता है विवरण",
		"giftCertficateTo": "{{currentBrand}} अनुभव प्रमाण पत्र भेंट करने के लिए",
		"giftCertficateDetails": " उपहार प्रमाण पत्र विवरण ",
		"giftOffer": "100% की छूट पर बुफे दोपहर का भोजन या रात के खाने के",
		"giftCode": "प्रमाण पत्र कोड",
		"certificateGifted": "प्रमाण पत्र भेंट",
		"confirmation": "वे एक एसएमएस प्राप्त होगा और विवरण के साथ एक ईमेल को सक्रिय करने के लिए उपहार प्रमाण पत्र",
		"receive_gift_certificate": "एक लाभ प्राप्त करें",
		"enter_the_certificate_code_placeholder": "कोड दर्ज करें",
		"receive_gift_certificate_error": "प्रमाण पत्र कोड में प्रवेश किया है या तो गलत, नहीं, वैध या गैर-हस्तांतरणीय",
		"receive_gift_certificate_proceed": "आगे बढ़ें",
		"receive_gift_certificate_otp_message": "एक OTP भेजा गया है पर पंजीकृत मोबाइल और ईमेल आईडी के साथ करने के लिए अपने दोस्त के हस्तांतरण की पुष्टि इस प्रमाण पत्र । OTP के लिए मान्य है 15 मिनट. एक बार की पुष्टि की है, इस प्रमाण पत्र में सुविधा होगी आपकी सदस्यता इस एप्लिकेशन का पेज.",
		"receive_membershipextension_ecashbenefit_confirmed_message": "आपके अनुरोध की पुष्टि की गई है। विवरण के साथ एक ईमेल आपके पंजीकृत ईमेल आईडी पर भेज दिया गया है।",
		"receive_gift_certificate_process_message": "आप उपयोग कर सकते हैं एक ही प्रक्रिया हस्तांतरण करने के लिए अतिरिक्त प्रमाण पत्र.",
		"button_got_it": "यह मिल गया",
		"dear": "प्रिय {{userName}}",
		"sincerely": "ईमानदारी से",
		"messageFrom": "संदेश से",
		"certificatesGifted": "प्रमाण पत्र भेंट",
		"certificatesGiftedTo": "प्रमाण पत्र भेंट करने के लिए",
		"giftedCertificateDetails": "उपहार प्रमाण पत्र विवरण",
		"smsEmailAsConfirmation": "आप एक एसएमएस प्राप्त होगा और एक ईमेल के रूप में पुष्टि",
		"validTill": "तक वैध",
		"personaliseGift": "अपने उपहार निजीकृत",
		"shareVideoGift": "एक संदेश जोड़ें और एक व्यक्तिगत वीडियो के साथ जाने के लिए उपहार",
		"shareVideoGiftMembership": "उपहार के साथ संदेश साझा करें",
		"videoSpecifications": "वीडियो के भीतर होना चाहिए 50 एमबी के आकार और करना चाहिए केवल भेजा जा करने के लिए किसी को कौन जानता है और आप स्वीकार करेंगे, आप से एक उपहार.",
		"words": "शब्दों",
		"confirmDetails": "विवरण की पुष्टि करें",
		"certificateGiftedTo": "अपने प्रमाण पत्र भेंट किया जा रहा है के लिए",
		"download": "डाउनलोड",
		"noMessageAvailable": "There is no message with this gifted experience."
	},
	"buyCertificate": {
		"title": "{{currentBrand}} उपहार कार्ड",
		"addToCart": "कार्ट में जोड़ें",
		"goToCart": "जाने के लिए गाड़ी",
		"addCertificate": "जोड़ें प्रमाण पत्र",
		"checkout": "चेकआउट",
		"payment_success": "आपका भुगतान सफल रहा है और लेन-देन की संख्या है {{transactionNumber}}.",
		"payment_success_without_transaction": "आपका भुगतान सफल है । ",
		"payment_success_description": "नव खरीदा {{currentBrand}} अनुभव उपहार कार्ड{{स्थानों}} {{areOrIs}} अब पर रखा अपनी सदस्यता पृष्ठ और तैयार कर रहे हैं होना करने के लिए भेंट की । ",
		"payment_success_button": "आगे बढ़ें",
		"noCertificate": "कोई प्रमाण पत्र नहीं पाया!",
		"cartEmpty": "गाड़ी खाली है । ",
		"used": "इस्तेमाल किया",
		"gifted": "भेंट",
		"archived": "संग्रहीत",
		"lapsed": "व्यपगत",
		"giftedTo": "भेंट करने के लिए",
		"on": "पर",
		"resend": "पुन: भेजें",
		"retrieveCertificate": "पुनः प्राप्त प्रमाण पत्र",
		"certificateRetrieved": "इस प्रमाण पत्र लिया गया है और स्थानों में अपनी सदस्यता फ़ोल्डर",
		"blankArchiveMsg": "किसी प्रमाणपत्र को संग्रहीत करने के लिए, अपने प्रमाणपत्र पर क्लिक करें और अपने प्रमाणपत्र के ऊपरी दाएं कोने पर (-) आइकन टैप करें। सभी संग्रहीत प्रमाण पत्रों को आवश्यकता के अनुसार वापस प्राप्त किया जा सकता है।",
		"blankLapsedMsg": "आपके समाप्त प्रमाण पत्र जो समाप्ति की तारीख से परे उपयोग नहीं किए गए हैं, इस टैब में दिखाई देंगे।",
		"multiPGmessage": "यह प्रमाणपत्र इस लेनदेन में नहीं खरीदा जा सकता है। आपसे अनुरोध है कि आप इस प्रमाणपत्र को अपने अगले लेनदेन में खरीद सकते हैं।"
	},
	"specialOffer": {
		"title": "मेरे विशेष ऑफर"
	},
	"updateCeleb": {
		"title": "अद्यतन जश्न मनाने के",
		"firstNameErr": "उचित पहला नाम दर्ज करें",
		"lastNameErr": "उचित अंतिम नाम दर्ज करें",
		"done": "किया",
		"delete": "हटाना"
	},
	"marriott_experience": {
		"title": "{{currentBrand}} अनुभव उपहार कार्ड",
		"comming_soon": "जल्द ही आ रहा है"
	},
	"signup_promo_code": {
		"invalid_promo": "अमान्य Promcode या रेफरल कोड",
		"apply": "लागू",
		"proceed": "आगे बढ़ें",
		"continue_as_guest": "जारी रखने के एक अतिथि के रूप में",
		"invalidFormat": "प्रोमोकोड प्रारूप सही नहीं है!"
	},
	"auto_populate": {
		"header_text": "ऑटो आबादी वाले संदेश",
		"message": "की अनुमति {{brandName}} App संदेश पढ़ने के लिए और नीचे दिए गए कोड दर्ज करें?",
		"buttonText": "की अनुमति"
	},
	"enroll_model": {
		"applied_text": "लागू",
		"apply_text": "लागू",
		"proceed": "आगे बढ़ें",
		"discount_applied": "छूट लागू",
		"referral_code_validated": "रेफरल कोड मान्य",
		"call_for_promocode": "कॉल के लिए एक प्रोमो कोड",
		"become_member": "एक सदस्य बन जाते हैं",
		"buy_membership_text": "खरीदें एक {{brandName}} सदस्यता",
		"gift_membership": "उपहार एक सदस्यता",
		"gift_membership_text": "उपहार एक {{brandName}} सदस्यता",
		"chooseFromProfile": "से चुनने प्रोफ़ाइल",
		"happyBirthday": "जन्मदिन मुबारक",
		"celebrateWithUs": "हमारे साथ जश्न मनाने",
		"havePromocode": "मैं एक प्रोमो कोड",
		"startTyping": "टाइपिंग शुरू",
		"whoseAreYouCelebrating": "किसका आप कर रहे हैं मना?",
		"pleaseArrangeFlowers": "कृपया की व्यवस्था के लिए फूलों का एक गुलदस्ता"
	},
	"promotion": {
		"offerEvents": {
			"selectCountryCity": "कृपया पहले देश और शहर का चयन करें!",
			"selectCity": "कृपया पहले शहर का चयन करें!",
			"setDate": "तारीख सेट करें",
			"price": "{{price}} + लागू कर बाद में",
			"guests": "{{applaudCount}} मेहमान",
			"noPromotions": "कोई प्रचार नहीं मिला!"
		},
		"unique": "अनोखा अनुभव",
		"signature": "हस्ताक्षर संग्रहण",
		"offer": "प्रस्ताव और घटनाएँ",
		"partner": "साझेदार लाभ",
		"personalServices": "व्यक्तिगत सेवाएँ",
		"activity": "क्रियाएँ हब",
		"visitorAlert": {
			"promotion": "यह लाभ केवल {{brandName}} सदस्यों के लिए उपलब्ध है।",
			"promotionButton": "{{brandName}} सदस्यता खरीदें",
			"giftCertificate": "आपके पास उपहार देने के लिए कोई प्रमाण पत्र नहीं है। आप एक प्रमाण पत्र खरीद सकते हैं और फिर उपहार दे सकते हैं।",
			"giftCertificateButton": "प्रमाण पत्र खरीदें"
		},
		"promotionDetail": {
			"buy": "खरीदें",
			"redeem": "रिडीम",
			"reserve": "रिज़र्व"
		},
		"noOutlets": "कोई परिणाम नहीं मिला!"
	},
	"months": {
		"january": "जनवरी",
		"february": "फरवरी",
		"march": "मार्च",
		"april": "अप्रैल",
		"may": "मई",
		"june": "जून",
		"july": "जुलाई",
		"august": "अगस्त",
		"september": "सितम्बर",
		"october": "अक्टूबर",
		"november": "नवंबर",
		"december": "दिसंबर"
	},
	"configJson": {
		"brandsName": "क्लब मैरियट",
		"currentBrand": "मैरियट",
		"appName": "clubmarriott"
	},
	"postcard": {
		"atTheHotel": {
			"title": "{{brandName}}",
			"description": "{{propertyName}} में {{currentBrand}} अनुभव का आनंद ले रहे हैं। #{{brandTag}}"
		},
		"feedback": {
			"title": "{{brandName}}",
			"description": "{{propertyName}} में {{currentBrand}} अनुभव का आनंद ले रहे हैं। #{{brandTag}}"
		},
		"redemption": {
			"title": "{{brandName}}",
			"description": "{{propertyName}} में {{currentBrand}} अनुभव का आनंद ले रहे हैं। #{{brandTag}}"
		},
		"checkInHotel": {
			"title": "{{brandName}}",
			"description": "{{firstName}} {{lastName}} ने {{propertyName}} में चेक-इन किया। {{currentBrand}} अनुभव का आनंद ले रहे हैं। #{{brandTag}}"
		},
		"createMemoryButton": "एक मेमोरी बनाएँ",
		"checkInHotelButton": "एक तस्वीर के साथ में जाँच करें",
		"checkInHotelWelcomeMsg": "{{PropertyName}} में चेक इन कर रहे हैं।",
		"placeholderText": "नाम दर्ज करें",
		"happy": "हैप्पी",
		"birthday": "बर्थडे",
		"celebrating": "सेलिब्रेटिंग",
		"anniversary": "सालगिरह",
		"imageSaveMsg": "छवि को गैलरी में सहेजा गया",
		"imageSaveError": "गैलरी में छवि सहेजने में त्रुटि"
	},
	"activities": {
		"certificatePurchased": "प्रमाणपत्र खरीदा गया",
		"certificateGifted": "को प्रमाण पत्र भेंट किया",
		"pointsPurchased": "अंक खरीदे गए",
		"pointsEarned": "अर्जित अंक",
		"membershipPurchased": "सदस्यता खरीदी",
		"membershipUpgraded": "सदस्यता अपग्रेड की गई",
		"membershipRenewed": "सदस्यता नवीनीकृत",
		"membershipGifted": "सदस्यता के लिए भेंट की",
		"membershipReactivated": "सदस्यता पुन: सक्रिय",
		"referralBenefitReceived": "रेफरल लाभ प्राप्त हुआ",
		"transaction": "लेन-देन",
		"cancelReservation": "रद्द किया गया आरक्षण",
		"pointsRedeemed": "पॉइंट्स रिडीम किए गए",
		"feedback": "प्रतिपुष्टि",
		"profileUpdate": "प्रोफ़ाइल अपडेट",
		"viewCheque": "चेक देखें",
		"membershipLapsed": "सदस्यता समाप्त हो गई",
		"lapsedCertificate": "व्यपगत प्रमाण पत्र",
		"giftReceived": "से उपहार मिला",
		"signup": "में स्वागत",
		"spouseMembershipAdded": "जीवनसाथी की सदस्यता जोड़ी गई",
		"cancelRedemption": "रद्द किया गया लाभ"
	},
	"IonDateTimeMonth": {
		"jan": "जनवरी",
		"feb": "फरवरी",
		"mar": "मार्च",
		"apr": "अप्रैल",
		"may": "मई",
		"jun": "जून",
		"jul": "जुलाई",
		"aug": "अगस्त",
		"sep": "सितंबर",
		"oct": "अक्टूबर",
		"nov": "नवंबर",
		"dec": "दिसंबर"
	},
	"IonDateTimeFullMonth": {
		"jan": "जनवरी",
		"feb": "फरवरी",
		"mar": "मार्च",
		"apr": "अप्रैल",
		"may": "मई",
		"jun": "जून",
		"jul": "जुलाई",
		"aug": "अगस्त",
		"sep": "सितंबर",
		"oct": "अक्टूबर",
		"nov": "नवंबर",
		"dec": "दिसंबर"
	},
	"IonDateTimeDays": {
		"sun": "रविवार",
		"mon": "सोमवार",
		"tue": "मंगलवार",
		"wed": "बुधवार",
		"thurs": "गुरुवार",
		"fri": "शुक्रवार",
		"sat": "शनिवार"
	},
	"IonDateTimeFullDays": {
		"sun": "रविवार",
		"mon": "सोमवार",
		"tue": "मंगलवार",
		"wed": "बुधवार",
		"thurs": "गुरुवार",
		"fri": "शुक्रवार",
		"sat": "शनिवार"
	},
	"paymentGateway": {
		"equityAlertHeader": "भुगतान असफल हुआ!",
		"equityAlert": "भुगतान सफल नहीं था। कृपया पुन: प्रयास करें।"
	},
	"appRatePopup": {
		"title": "क्या आप %@ को रेटिंग देंगे?",
		"message": "यह एक मिनट से अधिक नहीं लेगा और हमारे ऐप को बढ़ावा देने में मदद करता है। आपके समर्थन के लिए धन्यवाद!",
		"cancelButtonLabel": "जी नहीं, धन्यवाद",
		"laterButtonLabel": "मुझे बाद में याद दिलाना",
		"rateButtonLabel": "अब रेट करें"
	},
	"updatePopup": {
		"updateMessage": "इस ऐप का उपयोग जारी रखने  के लिए, हम आपसे नए संस्करण में अपडेट करने का अनुरोध करते हैं। यह अपडेट फ्री है।",
		"updateOkMessage": "इस अपडेट को अभी प्राप्त करने के लिए,<br> कृपया ठीक चुनें।<br> यह अपडेट निःशुल्क है।",
		"updateRequiredHeader": "अपडेट आवश्यक है",
		"updateOptionalHeader": "अपडेट उपलब्ध है",
		"ok": "ठीक है",
		"cancel": "रद्द",
		"update": "अपडेट करें"
	},
	"mbowPage": {
		"title": "MBOW"
	},
	"mbowDeliveryAddress": {
		"deleteHeader": "Delete Address?",
		"deleteMessage": "Are you sure you want to delete this address?",
		"deleteButtons": ["Cancel", "Delete"]
	}
}